// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"d05096a5","400":"5b886586"}[chunkId] + ".chunk.js";
};